import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles({
  container: {
    margin: "80px 0",
    textAlign: "center" as "center"
  }
});

interface IProps {
  children: React.ReactNode;
}

const Placeholder = ({ children }: IProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Typography variant="h3">{children}</Typography>
    </div>
  );
};

export default React.memo(Placeholder);
